/* @flow */
import * as React from "react";
import BackboneListener from "nexia_mobile/components/BackboneListener";
import Environment from "nexia_mobile/environment";
import Device from "nexia_mobile/models/device";
import { Group, Thermostat } from "nexia_mobile/models/mixins/device_features";

import { makeLoaderComponent } from "nexia_mobile/components/Routing/Loading";

const MultiZoneThermostatDetailsPage = makeLoaderComponent(() =>
  import("nexia_mobile/components/Pages/MultiZoneThermostatDetailsPage")
);
const GroupDetailsPage = makeLoaderComponent(() =>
  import("nexia_mobile/components/Pages/GroupDetailsPage")
);
const ThermostatDetailsPage = makeLoaderComponent(() =>
  import("nexia_mobile/components/Pages/ThermostatDetailsPage")
);
const DeviceDetailsPage = makeLoaderComponent(() =>
  import("nexia_mobile/components/Pages/DeviceDetailsPage")
);

const PivotDeviceDetailsPage = makeLoaderComponent(() =>
  import("nexia_mobile/components/Pages/PivotDeviceDetailsPage")
);

type Props = {
  appBar?: React.Node,
  isDashboard?: boolean,
  model: Device,
};

export default class DeviceDetails extends React.Component<Props> {
  render() {
    const { model } = this.props;
    const isCommercial = Environment.isCommercial();

    return (
      <BackboneListener listenTo={model} events={["change"]}>
        {() => {
          if (model.hasFeature(Thermostat) && model.hasFeature(Group)) {
            return <MultiZoneThermostatDetailsPage {...this.props} />;
          } else if (model.hasFeature(Group)) {
            return <GroupDetailsPage {...this.props} />;
          } else if (isCommercial) {
            return <PivotDeviceDetailsPage {...this.props} />;
          } else if (model.hasFeature(Thermostat)) {
            return <ThermostatDetailsPage {...this.props} />;
          } else {
            return <DeviceDetailsPage {...this.props} />;
          }
        }}
      </BackboneListener>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Details/DeviceDetails.jsx